import React, { useMemo } from 'react';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { FormattedMessage } from 'react-intl';

import { IconButton } from 'ui-components/components/button/icon-button';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';

import { CreateReturnDisabledReason } from './create-return-disabled-reason';
import messages from './messages';
import { useCreateReturn } from './use-create-return';
import { EventSourceStrings } from '../../../../tracking/tracking-constants';
import { useSalesOrderIdContext } from '../../../context/sales-order-id-context-provider';
import { usePendingReturnContext } from '../../context/pending-return-context-provider';

const getMessageDescriptor = (disabledReason) => {
  if (disabledReason === CreateReturnDisabledReason.HasPendingReturn) {
    return messages.hasPendingReturnTooltip;
  }

  if (disabledReason === CreateReturnDisabledReason.IsUnshipped) {
    return messages.isUnshippedTooltip;
  }
};

export const CreateReturnIconButton = () => {
  const salesOrderId = useSalesOrderIdContext();
  const { hasPendingReturn } = usePendingReturnContext();
  const { createReturn, isCreateReturnDisabled, createReturnDisabledReason } = useCreateReturn(
    salesOrderId,
    EventSourceStrings.ORDER_DETAILS_SIDEBAR,
  );

  const isDisabled = hasPendingReturn || isCreateReturnDisabled;

  const tooltipMessageDescriptor = useMemo(() => {
    const disabledReason = hasPendingReturn ? CreateReturnDisabledReason.HasPendingReturn : createReturnDisabledReason;

    if (isDisabled) {
      return getMessageDescriptor(disabledReason);
    }

    return messages.createReturnTooltip;
  }, [createReturnDisabledReason, hasPendingReturn, isDisabled]);

  return (
    <Tooltip>
      <span>
        <IconButton ariaLabelMessageDescriptor={messages.createReturn} disabled={isDisabled} icon={faPlus} onClick={createReturn} />
      </span>
      <TooltipContent>{tooltipMessageDescriptor ? <FormattedMessage {...tooltipMessageDescriptor} /> : null}</TooltipContent>
    </Tooltip>
  );
};
